import { extract } from '../extractors/newsSignals';
import { judgeSentiment } from '../judgments/newsSentiment';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function buildHtml(project, a, lang = 'zh') {
  const d = extract(project, a);
  if (!d) return '';
  const j = judgeSentiment(d.sentiment);
  const redList   = (lang === 'en' && d.redFlagsEn.length   ? d.redFlagsEn   : d.redFlags).slice(0, 6);
  const greenList = (lang === 'en' && d.greenFlagsEn.length ? d.greenFlagsEn : d.greenFlags).slice(0, 6);
  const summary = lang === 'en' ? (d.summaryEn || d.summaryZh) : d.summaryZh;

  if (!j && !redList.length && !greenList.length && !summary) return '';

  return `
<div style="border:1px solid #e5e7eb;border-radius:10px;overflow:hidden;margin-bottom:14px">
  <div style="padding:13px 16px;background:#fafafa;border-bottom:1px solid #f3f4f6;font-size:13px;font-weight:800;color:#111827">
    📰 ${txt(lang, '新闻语义信号', 'News Semantic Signals')}
    <span style="margin-left:8px;font-weight:400;font-size:10px;color:#94a3b8">AI · Surf</span>
  </div>
  <div style="padding:12px 16px">
    ${j ? `<div style="margin-bottom:8px"><span style="font-size:11px;color:#6b7280">${txt(lang, '整体情感', 'Overall sentiment')}: </span><span style="font-size:12px;font-weight:700">${j.emoji} ${txt(lang, j.labelZh, j.labelEn)}</span></div>` : ''}
    ${summary ? `<div style="margin-bottom:10px;font-size:11px;line-height:1.6;color:#374151;padding:6px 8px;background:#f9fafb;border-radius:4px">${summary}</div>` : ''}
    ${redList.length > 0 ? `<div style="margin-bottom:6px"><div style="font-size:10px;font-weight:700;color:#dc2626;margin-bottom:3px">🔴 ${txt(lang, '风险信号', 'Risk signals')}</div>${redList.map(s => `<div style="font-size:11px;color:#7f1d1d;padding-left:8px;line-height:1.6">· ${s}</div>`).join('')}</div>` : ''}
    ${greenList.length > 0 ? `<div><div style="font-size:10px;font-weight:700;color:#059669;margin-bottom:3px">🟢 ${txt(lang, '正面信号', 'Positive signals')}</div>${greenList.map(s => `<div style="font-size:11px;color:#064e3b;padding-left:8px;line-height:1.6">· ${s}</div>`).join('')}</div>` : ''}
  </div>
</div>`;
}
